import { byDesc } from '@utils/collections'

const getScoreComparedToAlternatives = (laptopEvaluations, laptop, keyCompared, isInverted) => {
  if (!laptop[keyCompared]) return 0

  const minPrice = laptop.price * 0.8
  const maxPrice = laptop.price * 1.2

  const alternativeLaptops = laptopEvaluations
    .filter(({ price }) => price > minPrice && price < maxPrice)
    .sort(byDesc('valueScore'))
    .slice(0, 10)

  const comparedValues = alternativeLaptops
    .map(alternativeLaptop => alternativeLaptop[keyCompared])
    .filter(Boolean)

  if (!comparedValues.length) return 0

  const max = Math.max(...comparedValues)
  const min = Math.min(...comparedValues)
  const score = Number((((laptop[keyCompared] - min) / (max - min)) * 9 + 1)
    .toFixed(2))

  return isInverted ? (10 - score) : score
}

export default conditionsPhrases => (benchmarkKey, toSentence, isInverted = false) =>
  ({ laptopEvaluations, laptop }) => {
    const score = getScoreComparedToAlternatives(
      laptopEvaluations,
      laptop,
      benchmarkKey,
      isInverted,
    )

    const { phrases } = conditionsPhrases
      .find(({ condition }) => condition(score)) || {}

    if (!phrases) return []

    return [toSentence(phrases, laptop)]
  }
